import { Icon } from '@design-system/components/atoms/icon/entities/icon.types';

export type AutoCompleteDestination = Readonly<{
  hotels: AutoCompleteDestinationHotel[];
  locations: AutoCompleteDestinationLocation[];
}>;

export type AutoCompleteDestinationHotel = Readonly<{
  Id: number;
  address: string;
  hotel_name: string;
  NearestIataCode: string;
  headline?: string;
}>;

export type AutoCompleteDestinationLocation = Readonly<{
  AsciiName: string;
  Id: number;
  Name: string;
  NameFull: string;
  Type: LocationType;
  TypeIcon: string;
  TypePriority: number;
  nearestIataCode: string;
}>;

export type InputDestinationPlace = Readonly<{
  Id: number;
  InputType: HotelDestinationInputType;
  address?: string;
  hotel_name?: string;
  headline?: string;
  AsciiName?: string;
  Name?: string;
  NameFull?: string;
  Type?: string;
  NearestIata?: string;
  Country?: string;
  isPopularSelection?: boolean;
  isTravelCitySearch?: boolean;
}>;

export type DestinationPlaceInfoPayload = Readonly<{
  id: string;
  type: HotelDestinationInputType;
}>;

export type DestinationPlaceInfoResponse = Readonly<{
  Id: number;
  Type: HotelDestinationInfoType;
  Name: string;
  NearestIata: string;
  NameFull?: string;
  Country?: string;
}>;

export enum HotelDestinationInputType {
  location = 'location',
  hotel = 'hotel',
  SearchBar = 'search-bar'
}

export enum HotelDestinationInfoType {
  LOCATION = 'LOCATION',
  HOTEL = 'HOTEL'
}

export enum LocationType {
  City = 'city',
  PointOfInterest = 'point_of_interest',
  Airport = 'airport',
}

export const LocationTypeIcon = {
  Default: Icon.Location,
  [LocationType.Airport]: Icon.Flights,
};

export const LocationTypePriority = {
  Default: 0,
  [LocationType.Airport]: 1,
};
